// extracted by css-extract-rspack-plugin
export default {"container":"auth-page-module__container___r5Fzr","isPartnerFlow":"auth-page-module__isPartnerFlow___ikAur"};